import { UrlSuffix } from '@/common/enums/qiniu';

export const QiniuImageUrl = (url: string) => {
  if (url && url.includes('img.linhuiba.com/') && !url.includes('-linhuiba')) {
    return url + UrlSuffix.Ori;
  } else if (url && url.includes('pmsimage.location.pub/') && !url.includes('-pms_')) {
    return url + UrlSuffix.PmsLarge;
  } else if (url && url.includes('data-images.location.pub/')) {
    return url;
  } else if (url && url.includes('images.location.pub/') && !url.includes('-location_')) {
    return url + UrlSuffix.locationOri;
  } else {
    return url;
  }
};

/**
 * @description: 根据七牛文件的 url，获取原图链接
 * @param {*} url
 * @return {*}
 */
export function getQiniuFileOriSuffix(url) {
  if (!url) {
    return '';
  }
  if (url.indexOf('middle-file.linhuiba.com/') > -1) {
    return '';
  } else if (url.includes('img.linhuiba.com')) {
    return UrlSuffix.Ori;
  } else if (url.includes('pmsimage.location.pub')) {
    // 来自 pms 的图片
    return UrlSuffix.PmsOri;
  } else {
    return '';
  }
}

/**
 * @description: 根据七牛文件的 url，获取预览链接
 * @param {*} url
 * @return {*}
 */
export function getQiniuFilePreviewSuffix(url) {
  if (!url) {
    return '';
  }
  if (url.indexOf('middle-file.linhuiba.com') > -1) {
    return '';
  } else if (url.includes('img.linhuiba.com')) { // 来自 邻汇吧场地 的图片
    return UrlSuffix.Wk;
  } else if (url.includes('pmsimage.location.pub')) { // 来自 pms 的图片
    return UrlSuffix.PmsLarge;
  } else {
    return '';
  }
}
